import { CWidgetStatsA } from './CWidgetStatsA.js';
import { CWidgetStatsB } from './CWidgetStatsB.js';
import { CWidgetStatsC } from './CWidgetStatsC.js';
import { CWidgetStatsD } from './CWidgetStatsD.js';
import { CWidgetStatsE } from './CWidgetStatsE.js';
import { CWidgetStatsF } from './CWidgetStatsF.js';

const CWidgetsStatsPlugin = {
    install: (app) => {
        app.component(CWidgetStatsA.name, CWidgetStatsA);
        app.component(CWidgetStatsB.name, CWidgetStatsB);
        app.component(CWidgetStatsC.name, CWidgetStatsC);
        app.component(CWidgetStatsD.name, CWidgetStatsD);
        app.component(CWidgetStatsE.name, CWidgetStatsE);
        app.component(CWidgetStatsF.name, CWidgetStatsF);
    },
};

export { CWidgetStatsA, CWidgetStatsB, CWidgetStatsC, CWidgetStatsD, CWidgetStatsE, CWidgetStatsF, CWidgetsStatsPlugin };
//# sourceMappingURL=index.js.map
